export enum AppSwitchLocation {
  app_switcher = 'app_switcher',
  promotion_modal = 'promotion_modal',
  menu = 'menu',
}
